import { lazyForPaint } from 'react-loosely-lazy';
import { withAsync } from 'view/common/with-async';

export const VerifyEmail = withAsync({
    loader: lazyForPaint(() => import(/* webpackChunkName: "verify-email" */ './hocs')),
});
